/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MRulesItemComponent as ɵa} from './rules-item.component';